import { render } from "./JFreturn.vue?vue&type=template&id=7bd43554&scoped=true"
import script from "./JFreturn.vue?vue&type=script&lang=js"
export * from "./JFreturn.vue?vue&type=script&lang=js"

import "./JFreturn.vue?vue&type=style&index=0&id=7bd43554&lang=scss&scoped=true"
import "./JFreturn.vue?vue&type=style&index=1&id=7bd43554&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd43554"]])

export default __exports__